import { Target } from 'lucide-react'
import { GoalsSpaceFields } from '@/components/features/goals/GoalsSpaceFields'
import { apiErrors, goalsSpaceModeOf } from '@/components/features/goals/goalsUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const GoalsPage = lazyPage(() => import('@/pages/Goals'), 'GoalsPage')

export const goalsOkrsModule: ModuleDefinition = {
  key: 'goalsOkrs',
  icon: Target,
  iconName: 'target',
  namespaces: ['goals'],
  ready: true,
  ListPage: GoalsPage,
  /* "One cycle" or "Several cycles" (F-50 criterion 1): short, so it sits on the details step. */
  setup: {
    wizardStep: 'details',
    defaultConfig: () => ({ mode: 'multi' }),
    validate: () => null,
    errorsFromApi: (err) => {
      const hit = apiErrors(err).find((e) => e.param === 'moduleConfig.mode' || e.param === 'mode')
      return hit?.message ? { mode: hit.message } : null
    },
    Fields: GoalsSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), mode: config?.mode === 'single' ? 'single' : 'multi' }),
      fromSpace: (space) => ({ mode: goalsSpaceModeOf(space.moduleConfig) })
    }
  },
  posting: false,
  /* A one-cycle space is born with its cycle (create wizard); the edit dialog has no follow-up for it. */
  singleItem: {},
  workflow: { trigger: { block: 'goals', hrPrefixes: ['key_result.', 'time.key_result_', 'time.goal_'] } }
}
